import React from "react";
import { Button } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';

function MyVerticallyCenteredModal(props) {
  console.log(props);
  const [email, setEmail] = React.useState("");
  const Confirm = () => {
    console.log(email);
    // setModalShow(false);

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email })
    };

    fetch(process.env.REACT_APP_IP + "/sendEmail", requestOptions)
      .then(response => response.json())
      .then(data => console.log(data))
      .then(props.onHide());
  }
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered>

      <Modal.Header closeButton>
      </Modal.Header>

      <Modal.Body>
        <h4>Invite My Friends</h4>
        <p>
          Enter your friend Email to invite them to try Lyra.
        </p>
        <TextField id="outlined-basic" label="Email" variant="outlined"
          onChange={(e) => setEmail(e.target.value)} />
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={Confirm}>Confirm</Button>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

function Model1(props) {
  return (
    <MyVerticallyCenteredModal
      show={props.show}
      onHide={props.hide}
    />
  );
}

export default Model1;